import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

export default function AuthCallback() {
  const { isAuthenticated, isLoadingAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoadingAuth) {
      if (isAuthenticated) {
        navigate('/Dashboard', { replace: true });
      } else {
        // Role was denied or no profile found — go back to landing
        // AuthContext already signed the user out and set authError if needed
        navigate('/', { replace: true });
      }
    }
  }, [isLoadingAuth, isAuthenticated, navigate]);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-slate-50 gap-4">
      <div className="w-10 h-10 border-4 border-slate-200 border-t-blue-600 rounded-full animate-spin" />
      <p className="text-slate-500 text-sm">Signing you in with Google…</p>
    </div>
  );
}
